import {base} from "react-netjoy";
import {GetFilmIdResultType} from "../../../../models/google_search";

const customSearchKeys = [
    {
        apikey: 'AIzaSyCQG6kV5avi8PcAC9yTd9oEY8lwGTytYZ4',
        both: '4f8763db269bff7d3',
        filma: '0fb7fa3e95e72dccd',
        imdb: 'dd2b7aee4e96b5de4'
    },
    {
        apikey: 'AIzaSyCSQyzGXH-yfFEU1L30EXaDwA2ZSqDWegs',
        both: '981cf1488e6050bf5',
        filma: '981cf1488e6050bf5',
        imdb: '981cf1488e6050bf5'
    },
    {
        apikey: 'AIzaSyBd1-N5D771vI7KXDaumbXWcoHFcJOvCtA',
        both: '73f417515d85d60db',
        filma: '73f417515d85d60db',
        imdb: '73f417515d85d60db'
    }
]

let currentKeysCollection = 0


export function getFilmsFilmaRequest(searchTerm: string, onSuccess: (res: any) => void, onFailure: (error: any) => void) {
    const cx = 'filma'
    return getFilmsGoogleSearchRequest(cx, searchTerm, onSuccess, onFailure)
}

export function getFilmsImdbRequest(searchTerm: string, onSuccess: (res: any) => void, onFailure: (error: any) => void) {
    const cx = 'imdb'
    return getFilmsGoogleSearchRequest(cx, searchTerm, onSuccess, onFailure)
}

export function getFilmsImdbFilmaRequest(searchTerm: string, onSuccess: (res: any) => void, onFailure: (error: any) => void) {
    const cx = 'both'
    return getFilmsGoogleSearchRequest(cx, searchTerm, onSuccess, onFailure)
}

function getFilmsGoogleSearchRequest(cx: string, searchTerm: string, onSuccess: (res: any) => void, onFailure: (error: any) => void) {
    const internalOnFailure = (error: any) => {
        console.log('currentKeysCollection', currentKeysCollection)
        if ((error.status === 429 || error.status === 400) && currentKeysCollection < customSearchKeys.length - 1) {
            currentKeysCollection = currentKeysCollection + 1
        } else {
            onFailure(error)
        }
    }
    const apiKey = customSearchKeys[currentKeysCollection].apikey
    const selectedCx = customSearchKeys[currentKeysCollection][cx]
    // https://ahrefs.com/blog/es/operadores-de-busqueda-avanzada-de-google/
    const urls = `https://www.googleapis.com/customsearch/v1?q=${encodeURI(searchTerm)} inurl:(www.imdb.com/title/ | www.filmaffinity.com/es/)&key=${apiKey}&cx=${selectedCx}`
    // const urls = `/v1?q=${res[0]}+${res[2]}&key=${apiKey}&cx=${cx}`
    const req = new base.Request<any, GetFilmIdResultType, any>()
    req.setEndpointFromState = () => urls
    req.transformResponseDataWithState = (res) => {
        const initial: GetFilmIdResultType = {}
        console.log(res)
        return res?.original?.data?.items?.reduce((acc:any, it: any) => {
            if (acc.imdb && acc.filmaffinity) return acc
            const imdbMatch = it.formattedUrl.match('https://www.imdb.com/title/([^/]*)/$')
            if (imdbMatch && !acc.imdb) {
                return {...acc, imdb:{id: imdbMatch[1], title: it.title, url: it.formattedUrl, image: it.pagemap?.cse_image[0]?.src}}
            }
            const filmaMatch = it.formattedUrl.match('https://www.filmaffinity.com/es/film([^/]*)(.html)$')
            if (filmaMatch && !acc.filmaffinity) {
                return {...acc, filmaffinity:{id: filmaMatch[1], title: it.title, url: it.formattedUrl, image: it.pagemap?.cse_image[0]?.src}}
            }
            return acc
        }, initial) || initial
    }
    req.transformErrorDataWithState = (error) => {
        console.log(error)
        return error
    }
    req.onSuccess = onSuccess
    req.onFailure = internalOnFailure
    return req
}
